import React from 'react';
import { COLORS, FONTS, inputStyle, cardStyle, handleInputFocus, handleInputBlur, primaryButtonStyle, secondaryButtonStyle } from '../signup/signupStyles';

const selectStyle = {
  ...inputStyle,
  appearance: 'none',
  backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'12\' height=\'8\' viewBox=\'0 0 12 8\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M1 1L6 6L11 1\' stroke=\'%23666\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E")',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 16px center'
};

const YesNoButton = ({ selected, onClick, label }) => (
  <button type="button" onClick={onClick} style={{
    flex: 1, padding: '12px 20px', fontSize: '15px', fontWeight: '600',
    borderRadius: '6px', cursor: 'pointer',
    border: selected ? `2px solid ${COLORS.salmon}` : `1.5px solid ${COLORS.border}`,
    backgroundColor: selected ? `${COLORS.salmon}10` : '#fff',
    color: selected ? COLORS.salmon : COLORS.muted,
    transition: 'all 0.2s'
  }}>{label}</button>
);

export const Screener = ({ questions, answers, onUpdateAnswer, onNext, onBack, opportunityPay }) => {
  const allRequired = questions.filter(q => q.required);
  const canContinue = allRequired.every(q => answers[q.id]);

  return (
    <div style={{
      minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
      alignItems: 'flex-start', justifyContent: 'center', padding: '80px 20px 40px',
      fontFamily: FONTS.system
    }}>
      <style>{`
        @media (max-width: 480px) {
          .opp-screener-card { padding: 32px 24px !important; }
        }
      `}</style>
      <div className="opp-screener-card" style={{ ...cardStyle, marginTop: '24px' }}>
        {/* Progress */}
        <div style={{
          fontSize: '13px', fontWeight: '500', color: COLORS.muted,
          textAlign: 'center', marginBottom: '24px'
        }}>
          Step 2 of 3
        </div>

        <h2 style={{
          fontFamily: FONTS.serif, fontSize: '24px', fontWeight: '700',
          color: COLORS.text, margin: '0 0 8px', textAlign: 'center'
        }}>
          Eligibility check
        </h2>
        <p style={{
          fontSize: '15px', color: COLORS.muted, margin: '0 0 24px',
          textAlign: 'center'
        }}>
          A few quick questions to see if you qualify for the {opportunityPay} study
        </p>

        {questions.map((q, i) => (
          <div key={q.id} style={{ marginBottom: i === questions.length - 1 ? '28px' : '20px' }}>
            <label style={{
              display: 'block', fontSize: '14px', fontWeight: '600',
              color: COLORS.text, marginBottom: '8px'
            }}>
              {q.question}{q.required ? '*' : ''}
            </label>

            {q.type === 'yesno' && (
              <div style={{ display: 'flex', gap: '10px' }}>
                <YesNoButton label="Yes" selected={answers[q.id] === 'Yes'}
                  onClick={() => onUpdateAnswer(q.id, 'Yes')} />
                <YesNoButton label="No" selected={answers[q.id] === 'No'}
                  onClick={() => onUpdateAnswer(q.id, 'No')} />
              </div>
            )}

            {q.type === 'select' && (
              <select value={answers[q.id] || ''} onChange={(e) => onUpdateAnswer(q.id, e.target.value)}
                style={selectStyle} onFocus={handleInputFocus} onBlur={handleInputBlur}>
                <option value="">Select...</option>
                {q.options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
              </select>
            )}
          </div>
        ))}

        {/* Inline privacy statement */}
        <p style={{
          fontSize: '12px', color: COLORS.muted, textAlign: 'center',
          margin: '0 0 20px', lineHeight: 1.5
        }}>
          Your answers are used only to check eligibility. Researchers never see your name or email.
        </p>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button onClick={onBack} style={secondaryButtonStyle}>Back</button>
          <button onClick={onNext} disabled={!canContinue} style={{
            ...primaryButtonStyle, flex: 1,
            opacity: canContinue ? 1 : 0.4,
            cursor: canContinue ? 'pointer' : 'not-allowed'
          }}>Submit Screener</button>
        </div>
      </div>
    </div>
  );
};
